import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { usePageModalNavigationItems } from "./PageModalNavigation.hook";
import PageModalNavigationItem from "./PageModalNavigationItem";

import "./PageModalNavigation.style.less";

const PageModalNavigation = ({ model, itemId, formatTitle }) => {
  const { previousItem, nextItem } = usePageModalNavigationItems(itemId);

  if (!previousItem && !nextItem) return null;

  const commonProps = { model, formatTitle };

  return (
    <div className="page-modal-navigation">
      <PageModalNavigationItem
        {...commonProps}
        icon={<LeftOutlined />}
        item={previousItem}
      />
      <PageModalNavigationItem
        {...commonProps}
        icon={<RightOutlined />}
        item={nextItem}
      />
    </div>
  );
};

export default PageModalNavigation;
